import { useEffect, useState } from 'react';
import { LoginHelper } from './LoginHelper';

/** Wait for profile_mode sync from API, then expose admin access. */
export function useAdminGate() {
	const [ready, setReady] = useState(false);
	const [isAdmin, setIsAdmin] = useState(false);

	useEffect(() => {
		let cancelled = false;
		(async () => {
			await LoginHelper.syncProfileModeFromServer();
			if (cancelled) {
				return;
			}
			setIsAdmin(
				LoginHelper.isLoggedIn() &&
					LoginHelper.getProfileMode() === LoginHelper.MODE_TYPE_ADMIN
			);
			setReady(true);
		})();
		return () => {
			cancelled = true;
		};
	}, []);

	return { ready, isAdmin };
}
